export * from '@fhs/routing/src/routes/menu/(menu)/[id]/[favoriteId]/edit';
export { default } from '@fhs/routing/src/routes/menu/(menu)/[id]/[favoriteId]/edit';
